import React, { FC } from "react"
import * as styles from "./styles.module.scss"
import { Props } from "./types"
import BlogThumbnail from "src/components/BlogThumbnail"
import { graphql, useStaticQuery, navigate } from "gatsby"
import { useComponentTexts } from "src/hooks/useComponentTexts"

const BlogArticles: FC<Props> = ({ nodes }) => {
  const data = useStaticQuery(graphql`
  query {
    allFile (filter: { relativePath: {regex: "/components/BlogArticles\/.+\\.yml/"}}) {
      nodes {
        childYaml {
          latestArticles
          popularArticles
        }
        relativePath
      }
    }
  }
`)
  const texts = useComponentTexts(data)

  return (
    <div className={styles.articlesContainer}>
      <div className={`content-wrapper ${styles.articlesContent}`}>
        <div className={styles.lastes}>
          <span className={styles.sectionTitle}>{texts.latestArticles}</span>
          {nodes.slice(3, 8).map((node: any) => (
            <div
              key={node.slug}
              className={styles.article}
              onClick={() => navigate(`/blog/${node.slug}`)}
            >
              <div>
                <h3
                  className={styles.articleTitle}
                  dangerouslySetInnerHTML={{ __html: node.title }}
                />
                <span className={styles.articleDate}>{node.date}</span>
              </div>
              <div className={styles.imgArticle}>
                <BlogThumbnail
                  url={
                    (node.acf && node.acf.thumbnail) ||
                    node.jetpack_featured_media_url
                  }
                />
              </div>
            </div>
          ))}
        </div>
        <div className={styles.popular}>
          <span className={styles.sectionTitle}>{texts.popularArticles}</span>
          {nodes.slice(8, 13).map((node: any) => (
            <div
              key={node.slug}
              className={styles.article}
              onClick={() => navigate(`/blog/${node.slug}`)}
            >
              <div>
                <h3
                  className={styles.articleTitle}
                  dangerouslySetInnerHTML={{ __html: node.title }}
                />
                <span className={styles.articleDate}>{node.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BlogArticles
